import type { SubjectState } from "./subject-state";

export interface SubjectStateDataset {
    name: string;
    subjects: SubjectState[];
}
